import AvailableProgram from "../Components/AvailableProgram/AvailableProgram";
import { useAuth } from "../Context/AuthContext";
import react, { useState, useEffect } from "react";
import { useHttpClient } from "../hooks/http-hook";
import { useTranslation } from "react-i18next";

function AvailablePrograms() {
  const { sendRequest } = useHttpClient();
  const { authData } = useAuth();
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  console.log(authData.role);

  useEffect(() => {
    const fetchPrograms = async () => {
      try {
        setLoading(true);
        const response = await sendRequest(
          process.env.REACT_APP_BACKEND_URL + "programs"
        );

        console.log("TEST" + response.programs[0].title);

        if (response && response.programs) {
          setPrograms(response.programs);
        } else {
          setPrograms([]);
        }

        setLoading(false);
      } catch (err) {
        console.error("ERROR:", err);
        setLoading(false);
      }
    };

    fetchPrograms();
  }, [sendRequest, authData.userId]);

  return (
    <div>
      <h1 className="text-center mb-3">{t("availableprograms")}</h1>

      {loading ? (
        <div className="spinner">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <AvailableProgram programs={programs} />
      )}
    </div>
  );
}

export default AvailablePrograms;
